import type { ApolloCache } from "@apollo/client/core"

export function evict({
  cache,
  id,
  typename
}: {
  cache: ApolloCache<object>
  id: string
  typename: string
}) {
  const cacheId = cache.identify({ id, __typename: typename })
  if (!cacheId) return
  cache.evict({ id: cacheId })
}
